import { render, staticRenderFns } from "./nueva-solicitud.vue?vue&type=template&id=1fa53563&"
import script from "./nueva-solicitud.component.ts?vue&type=script&lang=ts&"
export * from "./nueva-solicitud.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports